import { UIHeading2, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { DailyrentDiscount } from 'shared/components/DailyrentDiscount';

interface IDailyrentPriceProps {
  pricePerNight: string;
  priceDetails?: string;
  originalPricePerNight?: string;
  discountPercent?: string;
}

export const DailyrentPrice = ({
  pricePerNight,
  priceDetails,
  originalPricePerNight,
  discountPercent,
}: IDailyrentPriceProps) => {
  const showDiscount = originalPricePerNight && discountPercent;

  return (
    <div className={styles['dailyrent-price-container']} data-testid="dailyrent-price-info">
      <div className={styles['dailyrent-price']}>
        <UIHeading2 data-testid="dailyrent-price-per-night">{pricePerNight}</UIHeading2>
        {showDiscount && <DailyrentDiscount originalPrice={originalPricePerNight} discountPercent={discountPercent} />}
      </div>
      {priceDetails && (
        <UIText2 color="text-secondary-default" data-testid="dailyrent-price-details">
          {priceDetails}
        </UIText2>
      )}
    </div>
  );
};
